<template>
  <div>
    <div :class="['col-12', (posicao == 'center' ? 'text-center' : ''), 'p-3', 'mb-3']">
      <span class="titulo px-3">{{ texto }}</span>
      <span :class="[posicao_comp, 'col-11']"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TituloGrande",
  props: {
    texto: String,
    corFundo: String,
    posicao: {
      default: "center",
    },
  },
  components: {},
  computed: {
    posicao_comp: function () {
      var tmp = "";
      switch (this.posicao) {
        case "center":
          tmp = "linha_0";
          break;
        case "left":
          tmp = "linha_1";
          break;

        default:
          tmp = "linha_0";
          break;
      }
      return tmp;
    },
  },
  data() {
    return {
      corBG: String,
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.corFundo == undefined) {
        this.corBG = '#FFF'
      } else {
        this.corBG = this.corFundo
      }

      if(this.posicao != 'center'){
        this.corBG = 'transparent'
      }
    }, 200);
  },
};
</script>

<style scoped>
.titulo {
  color: white;
  /** var(--cor-base-texto); **/
  font-size: 46px;
  font-weight: bold;
  text-shadow: var(--cor-base-texto) 3px 0 6px;
  background-color: v-bind(corBG);
  z-index: 999;
}

.linha_0 {
  border-top: 2px solid var(--cor-base-texto);
  display: block;
  margin: 0 auto;
  margin-top: -32px;
}

.linha_1 {
  border-top: 2px solid var(--cor-base-texto);
  display: block;
}
</style>